import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div`
  margin: auto 0;
  color: ${props => props.theme.colors.bodyText};
  font-family: ${props => props.theme.font.family.regular};
  font-weight: 300;
  font-size: 0.9rem;
  line-height: 1.2;

  a {
    text-decoration: underline;
  }
`;

const PcBox = styled(DefaultBox)`
  max-width: 40%;
  text-align: left;

  @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
    max-width: 100%;
  }
`;

const MobileBox = styled(DefaultBox)`
  max-width: 100%;
  padding: 0.25rem 0;
  font-size: 1rem;
  text-align: center;
`;

export const GamblingWarningDefaultBox = styledByDevice(PcBox, MobileBox);
